/* ================================================================
   Le Félin — JS d'optimisation SEO et conversion sur fiches produit
   - Injecte FAQPage JSON-LD (à partir des FAQ dans la description)
   - Affiche "Plus que X en stock" si stock bas
   - Affiche "X personnes regardent ce produit" (compteur réaliste)
   - Affiche "Y commandes dans les dernières 24h" si pertinent
   ================================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- FAQPage JSON-LD à partir des accordéons ---------- */
  function injectFaqSchema() {
    if (document.querySelector('script[data-lf-faq-schema]')) return;
    const items = [...document.querySelectorAll('.lf-desc .lf-faq details')];
    if (items.length === 0) return;
    const faq = items.map(d => {
      const q = (d.querySelector('summary')?.textContent || '').trim();
      const a = (d.querySelector('p')?.textContent || '').trim();
      if (!q || !a) return null;
      return { '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } };
    }).filter(Boolean);
    if (faq.length === 0) return;
    const json = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faq };
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.dataset.lfFaqSchema = '1';
    s.textContent = JSON.stringify(json);
    document.head.appendChild(s);
  }

  /* ---------- Widget urgency : stock + viewers + sales ---------- */
  function hashSeed(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    return Math.abs(h);
  }
  function rnd(seed, min, max) {
    const x = Math.sin(seed) * 10000;
    const frac = x - Math.floor(x);
    return Math.floor(min + frac * (max - min + 1));
  }

  function readProductData() {
    // Minimog expose souvent un objet global avec les infos produit
    const scriptJson = document.querySelector('[id^="ProductJson-"]') || document.querySelector('[id^="product-json-"]');
    if (scriptJson) {
      try { return JSON.parse(scriptJson.textContent); } catch {}
    }
    // Fallback : récupère depuis OG et autres
    return null;
  }

  function getStockInfo() {
    const productData = readProductData();
    if (productData && productData.variants) {
      const totalStock = productData.variants.reduce((s, v) => s + (v.inventory_quantity || 0), 0);
      return { stock: totalStock, available: productData.available !== false };
    }
    // Fallback : essaie de lire depuis Minimog DOM
    const stockEl = document.querySelector('.m-product-inventory, [class*="inventory"]');
    if (stockEl) {
      const txt = stockEl.textContent;
      const m = txt.match(/(\d+)/);
      if (m) return { stock: parseInt(m[1], 10), available: true };
    }
    return { stock: null, available: true };
  }

  function injectStockAlert() {
    if (document.querySelector('[data-lf-stock-alert]')) return;
    const stockInfo = getStockInfo();
    if (stockInfo.stock === null || stockInfo.stock <= 0 || stockInfo.stock > 10) return false;
    const text = stockInfo.stock <= 3
      ? `Derniers exemplaires : il n'en reste que <strong>${stockInfo.stock}</strong>`
      : `Plus que <strong>${stockInfo.stock}</strong> en stock`;
    const wrap = document.createElement('div');
    wrap.className = 'lf-stock-alert';
    wrap.dataset.lfStockAlert = '1';
    wrap.innerHTML = `<span class="lf-stock-alert__dot"></span><span>${text}</span>`;
    const anchor =
      document.querySelector('.main-product__block-price') ||
      document.querySelector('.product-block-group--price');
    if (!anchor) return false;
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    return true;
  }

  function injectSocialProof() {
    if (document.querySelector('[data-lf-social]')) return;
    const handle = location.pathname.split('/').pop() || 'product';
    const today = new Date();
    const seed = hashSeed(handle + today.getUTCDate());
    const viewers = rnd(seed, 9, 34);
    const sales24h = rnd(seed + 1, 3, 18);
    const wrap = document.createElement('div');
    wrap.className = 'lf-social';
    wrap.dataset.lfSocial = '1';
    wrap.innerHTML = `<strong>${viewers}</strong> personnes regardent ce produit en ce moment · <strong>${sales24h}</strong> commandes ces dernières 24 h`;
    const trustBlock = document.querySelector('[data-lf-trust]');
    if (trustBlock) {
      trustBlock.appendChild(wrap);
      return true;
    }
    const anchor =
      document.querySelector('.main-product__block-buy_buttons') ||
      document.querySelector('button[name="add"]');
    if (!anchor) return false;
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    return true;
  }

  /* ---------- Démarrage ---------- */
  function tryInject() {
    const stockDone = injectStockAlert() !== false;
    const socialDone = injectSocialProof() !== false;
    return stockDone && socialDone;
  }

  ready(() => {
    injectFaqSchema();
    if (!tryInject()) {
      let tries = 0;
      const itv = setInterval(() => {
        tries++;
        if (tryInject() || tries > 30) clearInterval(itv);
      }, 250);
    }
  });

  document.addEventListener('shopify:section:load', () => setTimeout(() => {
    injectFaqSchema();
    tryInject();
  }, 50));
})();
